module.exports = __webpack_public_path__ + "img/banner-4th.87a1a88b.png";